import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'radName'
})
export class RadNamePipe implements PipeTransform {
  transform(rad): string {
    const name = rad.name;
    if (name) {
      const family = name.family;
      const given = name.given;
      const hasFamily = family && family.trim().length > 0;
      const hasGiven = given && given.trim().length > 0;

      if (hasFamily && hasGiven) {
        return family + ', ' + given;
      } else if (hasFamily) {
        return family;
      } else if (hasGiven) {
        return given;
      }
    }
    return '';
  }
}
